




































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import VolverButton from '@/reusable/Modal/VolverButton.vue';
import ContinuarButton from '@/reusable/Modal/ContinuarButton.vue';
import GuardarCambiosButton from '@/reusable/Modal/GuardarCambiosButton.vue';
import { FormChangeEvent, FormState } from '@/reusable/Form/formUtils';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import { Validator } from 'vee-validate/types/vee-validate';
import Confirmation from '@/components/Confirmation.vue';

import CalendarioForm from '@/pantallas/Calendarios/CalendarioForm.vue';
import { editarCalendario } from '@/pantallas/Calendarios/editarCalendario';

import {
  Calendario,
  CalendarioNuevoForm,
} from '@/pantallas/Calendarios/Calendario';

type CrearCalendarioFormState = {
  entity: CalendarioNuevoForm;
  validator: Validator;
  isDirty: boolean;
};

@Component({
  components: {
    Confirmation,
    CabeceraModal,
    CalendarioForm,
    ModalMantenedor,
    VolverButton,
    ContinuarButton,
    GuardarCambiosButton,
  },
})
export default class EditarCalendarioModal extends Vue {
  @Prop({ required: true }) show: boolean;
  @Prop({ required: true }) calendarioSeleccionado: CalendarioNuevoForm;

  pasos = {
    informacionGeneral: {
      accion: 'Crear - Información General',
      visible: true,
      step: 1,
    },
  };
  form: CrearCalendarioFormState = {
    entity: null,
    validator: null,
    isDirty: null,
  };
  showInfo: boolean = true;
  showGuardar: boolean = true;
  dialogConfirmacionClose: boolean = false;
  dialogConfirmacionGuardar: boolean = false;
  disableBtnContinuar: boolean = false;
  mensajeConfirmacionInactivo: any = '';
  hasErrors = false;
  isValid = false;
  estadoSwitch: boolean = true;
  nombreCalendarioEditado: string = '';

  /*Inactivar*/
  mensajeEliminar: any = '';
  titulomostrarAvisoDelete: string = '';
  dialogEliminar: Boolean = false;
  dialogErrorAsoc: Boolean = false;
  mensajeInactiva: string = '';
  inactivaInividual: Boolean = false;
  tituloEliminar: any = '';

  /* misc */

  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();

  /* event handlers */

  handleCerrar() {
    this.dialogConfirmacionClose = true;
  }

  handleCierreConfirmacionCerrar(isConfirmado: boolean) {
    this.dialogConfirmacionClose = false;
    if (!isConfirmado) {
      return;
    }
    this.$emit('cerrar');
  }

  handleConfirmacionGuardar(isConfirmado: boolean) {
    this.dialogConfirmacionGuardar = false;
    this.hasErrors = false;
    if (!isConfirmado) {
      return;
    }
    this.loadingService.showLoading();
    const calendarioEditado: CalendarioNuevoForm = {
      ...this.form.entity,
      id: this.calendarioSeleccionado.id,
    };
    return editarCalendario(calendarioEditado)
      .then(() =>
        this.$snotify.success(
          this.$t('mensajes.mensajesExito.editar', {
            entidad: 'Calendario',
            creadoA: 'editado',
          })
        )
      )
      .catch(() =>
        this.$snotify.error(
          `Ha ocurrido un error al intentar editar el Calendario.`,
          { timeout: 3000 }
        )
      )
      .finally(() => {
        this.loadingService.hideLoading();
        this.$emit('cerrarBtnGuardar');
      });
  }

  async handleGuardarClick() {
    this.handleEstadoSwitch(this.form.entity.estado);
    if (
      this.form.entity.frecuenciaSeleccionada === 1 &&
      (!this.form.entity.semanalDiasSemana ||
        this.form.entity.semanalDiasSemana.length === 0)
    ) {
      this.$snotify.error('Debe seleccionar al menos un día de la semana');
    } else {
      this.isValid = await this.form.validator.validateAll();
      this.hasErrors = true;
      if (this.isValid) {
        const totalAsociados = this.calendarioSeleccionado.totalAsociados;
        if (this.estadoSwitch) {
          this.nombreCalendarioEditado = this.form.entity.nombreCalendario;
          this.dialogConfirmacionGuardar = true;
        } else {
          if (totalAsociados === 0) {
            this.nombreCalendarioEditado = this.form.entity.nombreCalendario;
            this.dialogConfirmacionGuardar = true;
          } else {
            this.mensajeInactiva =
              'El Calendario tiene ' +
              (totalAsociados > 1
                ? 'asociaciones activas, '
                : 'una asociación activa, ') +
              'por esta razón no se podrá dejar inactivo.';
            this.dialogErrorAsoc = true;
            this.inactivaInividual = true;
          }
        }
      } else {
        this.form.isDirty = true;
      }
    }
  }

  async handleFormChange(event: FormChangeEvent) {
    this.form = event;
    this.isValid = true;
    if (this.form.isDirty) {
      this.hasErrors = this.form.validator.errors.items.length > 0;
    }
  }

  handleEstadoSwitch(estadoSwitch: boolean) {
    this.estadoSwitch = estadoSwitch;
    if (this.estadoSwitch) {
      this.mensajeConfirmacionInactivo = this.$t(
        'mensajes.crud.editar.mensaje',
        { entidad: 'el Calendario' }
      );
    } else {
      this.mensajeConfirmacionInactivo =
        'Al dejar como inactivo, no se podrán realizar asociaciones.' +
        ' ' +
        this.$t('mensajes.crud.editar.mensaje', {
          entidad: 'el Calendario',
        });
    }
  }
}
